<template>
    <div class="mainLayout">
        <div class="lookup lookupDiv inner">

                <p class="innerTitle adminList">Admin Areas</p>
                <button v-bind:class="adminButtonClass('site')" v-on:click="showSite" >Site Info</button>
                <button v-bind:class="adminButtonClass('security')" v-on:click="showSec">Security</button>
                <button v-bind:class="adminButtonClass('import')" v-on:click="showIE">Import/Export</button>

        </div>
        <div v-if="showSiteInfo" class="main inner personCard">
            <div class="personAddress">
                <div class="horizFlex">
                    <p class="personName">{{selectedResult.name}}</p> 
                    
                </div>
            
                <div class="horizFlex" v-if="!inEdit">
                    <ul class="textlist" >
                        <li>{{selectedResult.address1}}</li>
                        <li v-if="selectedResult.city!=null">{{selectedResult.city + ', ' + selectedResult.state + ' ' + selectedResult.zip}}</li>
                        <hr/>
                        <li>{{selectedResult.phone  | formatPhone}}</li>
                        <button class="linkButton linkButtonMedium" >{{ selectedResult.email }}</button>
                    </ul>
                    
                </div>
                 <!-- edit fields -->
                    <div class="vertFlex" v-if="inEdit">
                        <div class="horizFlex">
                            <label class="locationtitle">{{locationText}}</label>
                        </div>
                        
                        <div class="horizFlex">
                            <label for="" class="editLabel">Address Line 1</label>
                            <input class="editField" v-model="selectedResult.address1"/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">City</label>
                            <input  class="editField" v-model="selectedResult.city"/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">State</label>
                            <select name="" id="" class='editCombo' v-model="selectedResult.stateId">
                                <option v-for="state in states" :key="state.id" :value="state.ID">
                                    {{state.Name}}
                                </option>
                            </select>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">Zip</label>
                            <input  class="editField" v-model="selectedResult.zip"/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">Phone</label>
                            <input  class="editField" v-model="selectedResult.phone"/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">Email</label>
                            <input class="editField"  v-model="selectedResult.email"/>
                        </div>
                        
                        
                        
                        
                        
                    </div>
            </div>
            <div class="personAction" v-if="!inEdit">
                    <button class="buttonPerson" v-on:click="editSite()" :disabled="disableEdit">{{editButtonText}}</button>
                </div>
                <div class="personAction" v-if="inEdit">
                    <button class="buttonPerson" v-on:click="saveSite()">{{saveButtonText}}</button>
                    <button class="buttonPerson" v-on:click="cancelEditSite()">{{cancelButtonText}}</button>
                    <label for="" class="error">{{errorMessage}}</label>
                </div>
        </div>
        <div v-if="showSecurity" class="main  ">
            <div class="personAddress">
                <div class="horizFlex spaced">
                    <p class="personName">Security</p> 
                     <button class="addButton" v-on:click="addNewPerson()" :disabled="disableEdit">Add Person</button>
                </div>

                <!-- edit fields -->
                    <div class="vertFlex" v-if="inNewPerson">
                        <form ref="newpersonform">
                        <div class="horizFlex">
                            <label class="locationtitle">New Person</label>
                        </div>
                        
                        <div class="horizFlex">
                            <label for="" class="editLabel">First Name*</label>
                            <input class="editField" v-model="newperson.firstName" required/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">Last Name*</label>
                            <input  class="editField" v-model="newperson.lastName" required/>
                        </div>
                        
                        <div class="horizFlex">
                            <label for="" class="editLabel">Phone*</label>
                            <input  class="editField" v-model="newperson.phone" required/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">Email*</label>
                            <input class="editField" type="email"  v-model="newperson.email" required/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">Rec Card Number</label>
                            <input class="editField"  v-model="newperson.code"/>
                        </div>
                        <div class="horizFlex">
                            <label class="requiredtext">* required</label>
                        </div>
                        <div class="horizFlex">
                            <button class="buttonPerson" type="button" v-on:click="savePerson()">{{saveButtonText}}</button>
                            <button class="buttonPerson" v-on:click="cancelEditPerson()">{{cancelButtonText}}</button>
                        </div>
                        </form>
                    </div>
            </div>
            <div class="scrollDiv">
                
                <div v-for="item in securityList" :key="item.id" >
                    <securityitem :clubs="clubs" :securityItem="item" :canEdit="canEdit" v-on:refreshdata="getSecurity()"/>
                </div>    
            </div>
             <!-- <div class="secRights inner ">
                <div class="inactiveCheck">
                    <input type="checkbox" id="right1" >
                    <label for="right1" class="rosterName">View Members</label>
                </div>
                <div class="inactiveCheck">
                    <input type="checkbox" id="right1" >
                    <label for="right1" class="rosterName">Edit Members</label>
                </div>
                <div class="inactiveCheck">
                    <input type="checkbox" id="right1" >
                    <label for="right1" class="rosterName">View Clubs</label>
                </div>
                <div class="inactiveCheck">
                    <input type="checkbox" id="right1" >
                    <label for="right1" class="rosterName">Edit Clubs</label>
                </div>
                <div class="inactiveCheck">
                    <input type="checkbox" id="right1" >
                    <label for="right1" class="rosterName">View Elections</label>
                </div>
                <div class="inactiveCheck">
                    <input type="checkbox" id="right1" >
                    <label for="right1" class="rosterName">Edit Elections</label>
                </div>
                <div class="inactiveCheck">
                    <input type="checkbox" id="right1" >
                    <label for="right1" class="rosterName">Adminster Site Info</label>
                </div>
                 <div class="inactiveCheck">
                    <input type="checkbox" id="right1" >
                    <label for="right1" class="rosterName">Adminster Security Groups</label>
                </div>
                 <div class="inactiveCheck">
                    <input type="checkbox" id="right1" >
                   <label for="right1" class="rosterName">Adminster Import Export</label>
                </div>
            </div> -->
        </div>
        <div v-if="showImportExport" class="main inner">
            <div class="personAddress">
                <div class="horizFlex">
                    <p class="personName">Import Export</p> 
                </div>
            
                <div class="horizFlex" v-if="importStarted">
                    <p>Import processing. Please check results in 5 minutes.</p>
                    <button class="ieButton" :disabled="disableEdit" v-on:click="resetimport">Upload another file</button>
                </div>

                
               <!--  <div class="horizFlex">
                    <ul class="textlist" >
                        <li>Import Staff Roster</li>
                        
                        <button class="ieButton" :disabled="disableEdit" v-on:click="importstaff">Import</button>
                    </ul>
                </div> -->
                <div class="horizFlex" v-if="!importStarted">
                    <ul class="textlist" >
                        <li>Import Club List</li>
                        <input type="file" @change="Image_onFileChanged" accept=".csv"/>
                     <!--    <div class="horizFlex">
                            <input type="checkbox" class="importcheck" v-model="deactivateMembersOnClubImport"/>
                            <p>Deactivate club members not in new list</p>
                        </div> -->
                        <div class="vertFlex">
                            <button class="ieButtonwide" :disabled="disableEdit" v-on:click="importclub('AddAndDeactivate')">Import Clubs - Add And Deactivate</button>
                            <button class="ieButtonwide" :disabled="disableEdit" v-on:click="importclub('AddOnly')">Import Clubs - Add Only</button>
                            <button class="ieButtonwide" :disabled="disableEdit" v-on:click="importclub('ReplaceAll')">Import Clubs - Replace All</button>
                        </div>
                        
                         <div class="horizFlex" >
                            <p class="message">{{errorMessage}}</p>
                        </div>
                    </ul>
                </div>
                
                <div class="horizFlex topborder" v-if="!importStarted">
                    <ul class="textlist" >
                        <li>Import Full RCSCW Member Roster</li>
                        
                        <button class="ieButton" :disabled="disableEdit" v-on:click="importmaster">Import</button>
                    </ul>
                </div>
            </div>
            
        </div>
            
    </div>

  
</template>

<script>
import {HTTP} from '../Repository'
import securityitem from './SecurityItem.vue'
import tokenhelper from '../tokenhelper.js'
export default {
    mixins:[tokenhelper],
    props:{
        canEdit:{
            type:String,
            default:'false'
        },
    },
    components:{
        securityitem
    },
    data(){
        return{
            showSiteInfo:true,
            showSecurity:false,
            showImportExport:false,
            selectedResult:{},
            inEdit:false,
            editButtonText:'Edit',
            saveButtonText:'Save',
            cancelButtonText:'Cancel',
            errorMessage:'',
            states:{},

            securityList:[
                {
                    id:1,
                    name:'Joe Shmo',
                    roleName:'Admin--PeopleEditor',
                    appliesToClub:'All'
                },
                {
                    id:1,
                    name:'Jane Shmo',
                    roleName:'Admin--ClubEditor',
                    appliesToClub:'Agriculture'
                },
                {
                    id:1,
                    name:'Fred Flinstone',
                    roleName:'Admin--ElectionViewer',
                    appliesToClub:'All'
                },
            ],
            clubs:[],

            inNewPerson:false,
            newperson:{
                firstName:'',
                lastName:'',
                email:'',
                phone:''
            },
            selectedFile:null,
            selectedFileURL:null,
            deactivateMembersOnClubImport:true,
            importStarted:false
        }
    },
    mounted(){
        this.getStates()
        this.getSite()
        this.getSecurity()
        this.getClubs()
    },
    computed:{
    	disableEdit:function(){
            return this.canEdit=='false' || this.canEdit=='False'
        },
    },
    filters: {
        formatPhone(phn) {
            if(phn!=null){
                return "(" + phn.substring(0,3) + ") " + phn.substring(3,6) + "-" + phn.substring(6);       
            }
            
            
        }
    },
    methods:{
        AddTokenToAPI(){
            var token = this.getToken()   
            HTTP.defaults.headers.post['token']=token
        },
        addNewPerson(){
            this.inNewPerson=true
        },
        savePerson(){
            if(this.$refs.newpersonform.checkValidity()){
            let req = {
                Person:this.newperson
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('savenewadmin',req)
            .then(response=>{

                if(response.data.Successful){
                    
                    //this.inNewPerson=false
                    //this.getSecurity();
                }else{
                    this.errorMessage="API Error: " + response.data.RequestException.Message;
                }
                this.pleaseWait=false;
                this.inNewPerson=false
                    this.getSecurity();
                //this.getClub(this.selectedResult.id)
            })
            .catch(e=>{
                this.pleaseWait=false;
                console.log('saveclub fail')
                return e
            });
            }
        },
        cancelEditPerson(){
            this.inNewPerson=false
        },
        getClubs(){

            let req = {
                memberID:"1"
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('clubs',req)
            .then(response=>{
                this.clubs = response.data.ClubList
          
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });

        },
        getStates(){
            let req = {
                memberID:"1"
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('states',req)
            .then(response=>{
              
                this.states = response.data.ValueList
               
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });
        },
        showSite(){
            this.showSiteInfo=true
            this.showSecurity=false
            this.showImportExport=false
        },
        showSec(){
            this.showSiteInfo=false
            this.showSecurity=true
            this.showImportExport=false
        },
        showIE(){
            this.showSiteInfo=false
            this.showSecurity=false
            this.showImportExport=true
        },
        adminButtonClass(adminName){
            if(adminName=="site"){
                if(this.showSiteInfo){
                    return "adminButtonSelected"
                }else{
                    return "adminButton"
                }

            }else if(adminName=="security"){
                if(this.showSecurity){
                    return "adminButtonSelected"
                }else{
                    return "adminButton"
                }

            }else if(adminName=="import"){
                if(this.showImportExport){
                    return "adminButtonSelected"
                }else{
                    return "adminButton"
                }

            }
        },
        getSite(){
            

            let req = {
                clubId:0
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('mainlocation',req)
            .then(response=>{
                this.selectedResult = response.data.club
                this.isSelectedResult=true;
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });
            
        },
        editSite(){
            this.inEdit=true
        },
        
        cancelEditSite(){
            this.inEdit=false
            
        },
        saveSite(){
            let req = {
                club:this.selectedResult
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('saveclub',req)
            .then(response=>{

                if(response.data.success){
                    
                    this.inEdit=false
                }else{
                    this.errorMessage="API Error: " + response.data.RequestException.Message;
                }
                this.pleaseWait=false;
                this.getClub(this.selectedResult.id)
            })
            .catch(e=>{
                this.pleaseWait=false;
                console.log('saveclub fail')
                return e
            });
        },
        getSecurity(){
            let req = {
                personId:"-1"
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('adminaccessdata',req)
            .then(response=>{
              
                this.securityList = response.data.accessList
               
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });
        },
        
       Image_onFileChanged(event){
            this.selectedFile = event.target.files[0];
            this.selectedFileURL = URL.createObjectURL(this.selectedFile);
        },
        resetimport(){
            this.selectedFile=null
            this.importStarted=false
        },
         importclub(importfolder){
            this.errorMessage=''
            if (this.selectedFile==null){
                this.errorMessage="Please select a file to upload"
                return
            }
            const mypostparams = new FormData();
            if (this.selectedFile!=null){
                mypostparams.append('Image', this.selectedFile, this.selectedFile.name);
            }
            mypostparams.append('folder',importfolder)
            this.AddTokenToAPI();
            HTTP.post('importclub_byfolder',mypostparams)
            .then(response=>{
                console.log(response)
                if(response.data.Successful){
                    this.importStarted=true
                 
                }else{
                    this.errorMessage=response.data.message;
                    this.showError=true;
                }
            })
            .catch(e=>{
                console.log(e)
                this.errorMessage=e;
                this.showError=true;
            });
 
        },
        importmaster(){
            this.AddTokenToAPI();
            HTTP.post('importmaster',null)
            .then(response=>{
                console.log(response)
                if(response.data.Successful){
                    this.importStarted=true
                 
                }else{
                    this.errorMessage=response.data.message;
                    this.showError=true;
                }
            })
            .catch(e=>{
                console.log(e)
                this.errorMessage=e;
                this.showError=true;
            });
        },
        importstaff(){
            this.AddTokenToAPI();
            HTTP.post('importstaff',null)
            .then(response=>{
                console.log(response)
                if(response.data.Successful){
                    this.importStarted=true
                 
                }else{
                    this.errorMessage=response.data.message;
                    this.showError=true;
                }
            })
            .catch(e=>{
                console.log(e)
                this.errorMessage=e;
                this.showError=true;
            });
        }
    }
}
</script>

<style scoped>
/* main */
.mainLayout{
    display:grid;
    grid-template-columns:1fr 2fr 2fr;
    grid-template-rows:1fr 3fr;
    grid-template-areas: 
    "lookup main main"
    "lookup main main";
}
/*areas*/
.lookup{
    grid-area:lookup;
}
.main{
    grid-area:main;   
}
.detail{
    grid-area:detail; 
}
.scrollDiv{
    height:550px;
    overflow-x:hidden;
    overflow-y:scroll;
}
.inner{
    border-radius:10px; 
    margin:10px;
    padding:0px;
    text-align: left;
    background-color: white;
}
.innerInactive{
    background-color: lightgray;
}
.innerTitle{
    font-size:x-large;
    color:rgb(0,158,192);
}
.horizFlex{
  display:flex;
  flex-direction: row;
  
}
.spaced{
    justify-content: space-between;
}
.linkButton{
  background-color: transparent;
  color: rgb(0,158,192);
  font-size:small;
  border:none;
  padding:0px;
}
.linkButtonMedium{
  font-size:medium;
  
}

.adminButton{
    grid-area:add;
    width:96%;
    margin:5px;
    background-color:rgb(196, 218, 226);
    border:none;
    border-radius:10px;
    padding:10px;
    color:rgb(0,158,192);
    font-size:medium;
    /* background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 200px;
   height:40px;
   margin-top:20px;
   margin-right:20px;
    margin-left:10px; */
}
.adminButtonSelected{
    grid-area:add;
    width:96%;
    margin:5px;
    padding:10px;
    font-weight:bold;
    outline-style:none;
    border-radius:10px;
    border-color:rgb(238,120,45);
    background-color:rgb(196, 218, 226);
    border-width:2px;
    border-style:solid;
    font-size:medium;
    color:rgb(0,158,192);
    /* background-color:rgb(255, 173, 122);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 200px;
   height:40px;
   margin-top:20px;
   margin-left:10px; */

}

.fileBrowse{
    margin-right:20px;

}
.ieButton{
 
    background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 100px;
   height:50px;
    margin-top:10px;
   
}
.ieButtonwide{
 
    background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 250px;
   height:50px;
    margin-top:10px;
   
}
.adminList{
    margin-left:10px;
}
/*security*/
.security{
    display:grid;
    grid-template-columns:1fr 2fr;
    grid-template-areas: 
    "groups rights";
}

/*lookup*/
.lookupDiv{
    grid-area:lookup;
    height:620px;
    padding-left:10px;
    padding-right:10px;
}

.lookupText{
    border-width: 1;
    border-color:darkgray;
    border-radius: 5px;
    font-size:inherit;
    width:160px;
}

.lookupGo{
    background-color: rgb(238,120,45);
    border:none;
    border-radius:5px;
    margin-left:3px;
    color:white;
}
.lookupSelect{
  outline-color:rgb(238,120,45);
  outline-width:2px;
  border-radius: 5px;
  font-size:inherit;
  width:200px;
  margin-bottom:5px;
}

.lookupResults{
    padding:0px;
    margin-top:10px;
}
.resultButton{
    width:96%;
    margin:5px;
    background-color:rgb(196, 218, 226);
    border:none;
    border-radius:10px;
    padding:10px;
    color:rgb(0,158,192);
    font-size:medium;
}
.resultButton:focus{
    /* color:rgb(238,120,45); */
    font-weight:bold;
    outline-style:none;
    border-color:rgb(238,120,45);
    border-width:2px;
    border-style:solid;
}
/* personcard */
.personCard{
    display:grid;
    grid-template-columns:600px auto 120px;
    grid-template-rows:auto;
    grid-template-areas: 
    "address space personaction";
}
.personPhoto{
    grid-area:photo;
}
.image{
    margin:20px;
}
.personAddress{
    grid-area:address;
    display:flex;
    flex-direction: column;
    justify-content:flex-start;
    margin-left:10px;
}
.personAction{
    grid-area:personaction;
    display:flex;
    flex-direction: column;
    text-align: center;
}
.locationtitle{
    color:rgb(0,158,192);
    margin:5px;
}
.requiredtext{
    color:red;
    margin:5px;
}
.personName{
    font-size:xx-large;
    font-weight:bold;
    color:rgb(0,158,192);
    margin-bottom:5px;
    margin-top:10px;
}
.textlistdiv{
    text-align:left;
}
.textlist{
    list-style-type:none;
    padding-left:0;
    margin-right:60px;
}
.paidmain{
    color:green;
    font-size:large;
    margin-top:20px;
    margin-left:30px;
}
.unpaidmain{
    color:red;
    font-size:large;
    margin-top:20px;
    margin-left:30px;
}
.paid{
    color:green;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.unpaid{
    color:red;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.inactive{
    color:rgb(53, 48, 48);
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
/* club item */
.itemDetailOpen{
    display:grid;
    grid-template-columns:300px auto 40px 120px;
    grid-template-rows:1fr 1fr;
    grid-template-areas: 
    "clubtitle space paid action"
    "clubdate space paid action";
    height:140px;
}
.itemDetail{
    display:grid;
    grid-template-columns:300px auto 40px 120px;
    grid-template-rows:1fr;
    grid-template-areas: 
    "clubtitle space paid action";
}
.itemSpace{
    grid-area:space;
    text-align:center;
    display: flex;
    flex-direction: column-reverse;
}
.clubTitle{
    grid-area:clubtitle;
    margin-left:10px;
}
.clubDate{
    margin-left:10px;
}
.titleGrid{
    display:grid;
    grid-template-columns:200px auto 100px 100px;
    grid-template-rows:1fr 1fr 1fr;
    grid-template-areas: 
    "maintitle space paid action"
    "address1 phone paid action"
    "address2 email paid action";
}
.itemAction{
    grid-area:action;
    display:flex;
    flex-direction: column;
    text-align: center;
}

/* itemtitle */
.itemTitleBar{
    display:grid;
    grid-template-columns:700px  auto 150px 110px;
    grid-template-rows:auto;
    grid-template-areas: 
    "title  space inactive add";
    margin-left:10px;
    margin-right:10px;
  
}
.itemTitle{
    grid-area:title;
    
}
.itemBarTitle{
    font-size:x-large;
    /* color:rgb(0,158,192); */
    color:rgb(0,158,192);
    font-weight: bold;
}
.itemBarSubTitle{
    font-size:large;
    color:rgb(0,158,192);
    /* color:rgb(0,158,192); */
    margin-top:30px;
    margin-left:30px;
}
.inactiveCheck{
    grid-area:inactive;
    margin-top:30px;
    color:rgb(0,158,192);
}
.addButton{
    grid-area:add;
    background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 120px;
   height:40px;
   margin-top:20px;
   margin-right:20px;
}
.bold{
    font-weight: bold;
}

.button{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 0px 20px;
   width: 85px;
}
button:disabled{
    background-color:lightgray;
}
.buttonPerson{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 5px 20px;
   width: 85px;
}


.innerTransparent{

    padding:0px;
    text-align: left;

}


.editLabel{
    width:120px;
    margin:5px;
}
.editField{
    border-width: 1;
    border-color:darkgray;
    border-radius: 5px;
    font-size:inherit;
    width:160px;
    margin:5px;
}
.editCombo{
    border-width: 1;
    border-color:darkgray;
    border-radius: 5px;
    font-size:inherit;
    width:170px;
    margin:5px;
}


.importcheck{
    margin-top:18px;
    margin-right:5px;
}
.topborder{
    border-top:darkgray 1px solid;
}
.message{
    color:red;
}
.vertFlex{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>

